export abstract class UrlBuilder {

  abstract getBaseUrl(): string;

  buildUrl(path: string): string {
    return this.getBaseUrl() + path;
  }
}
